/**
Author - Shreshtha Sharma
Git - https://github.com/shreshtha-wealthy
**/

import BrokerageCharges from "./BrokerageCharges";

export default BrokerageCharges;
